import React, { Component } from "react"
import PropTypes from "prop-types"

import AnimationEvent from "app/scripts/animation_event"

import colors from "foundation/_colors.scss?variables"
import classnames from "classnames"
import Fittty from "shared/components/fittty"

import "../connect_button/connect_button.scss"

export default class ReconnectButton extends Component {
  state = {
    connected: true,
    playDisableAnimation: false,
    playMeterAnimation: false,
    playSuccessAnimation: false,
    showKnob: this.props.showKnob,
    ctaCopy: "",
    knobBgColor: {
      backgroundColor: `#${this.props.mainService.brand_color}`,
    },
  }

  render() {
    const {
      playDisableAnimation,
      playSuccessAnimation,
      playMeterAnimation,
      showKnob,
      connected,
      knobBgColor,
      ctaCopy,
    } = this.state
    const showKnobStyle = showKnob ? { opacity: 1 } : { opacity: 0 }

    return (
      <div styleName="connect-button-outline">
        <div
          style={this.props.defaultBgColor}
          styleName="connect-button"
          onClick={this.handleClick}
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify({
            object_type: "disconnect_button",
            object_id: ctaCopy,
            location_type: "connection",
          })}
        >
          <div styleName="meter-container">
            <div
              id="progress-meter"
              styleName={classnames({
                meter: playMeterAnimation,
              })}
            />
          </div>
          <div
            id="connect-ball"
            styleName={classnames({
              "service-icon": true,
              "slide-in": playDisableAnimation,
              "alt-brand-color": this.props.knobBgColorForDarkBrands,
              connected,
            })}
            style={{ ...knobBgColor, ...showKnobStyle }}
          >
            {this.props.programmable && (
              <img
                src={
                  this.props.mainService.lrg_monochrome_image_url ||
                  this.props.mainService.lrg_variant_image_url
                }
              />
            )}
          </div>
          <div
            styleName={classnames({
              "connect-cta": true,
              connected,
              "fade-out-fade-in": playSuccessAnimation,
            })}
            id="cta-copy"
          >
            <div styleName={classnames({ "no-knob": !showKnob })}>
              <Fittty
                maxSize={this.props.connectButtonMaxFontSize}
                minSize={14}
                text={ctaCopy}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleClick = event => {
    event.preventDefault()
    this.props.onConnectClick()
  }

  componentDidMount() {
    if (!this.props.connected && this.state.connected) {
      this.unlatch()
    }
  }

  unlatch = () => {
    const { disconnectClicked } = this.props

    // don't play aninmations if the flow has not been started in this "session"
    if (!disconnectClicked) {
      this.setState({
        connected: false,
        playDisableAnimation: false,
        playMeterAnimation: false,
        ctaCopy: this.ctaCopyToConnect(),
      })
    } else {
      this.knobElement = document.querySelector("#connect-ball")
      this.setState(
        {
          connected: false,
          playDisableAnimation: true,
          showKnob: true,
          ctaCopy: "",
        },
        () => {
          this.knobElement.addEventListener(
            AnimationEvent(),
            this.handleKnobAnimationEnd
          )
        }
      )
    }
  }

  handleKnobAnimationEnd = () => {
    this.meterElement = document.querySelector("#progress-meter")
    this.setState(
      {
        showKnob: false,
        ctaCopy: "Disconnecting…",
        playMeterAnimation: true,
        playDisableAnimation: false,
        playSuccessAnimation: false,
      },
      () => {
        this.meterElement.addEventListener(
          AnimationEvent(),
          this.handleMeterAnimationEnd
        )
        this.knobElement.removeEventListener(
          AnimationEvent(),
          this.handleKnobAnimationEnd
        )
      }
    )
  }

  handleMeterAnimationEnd = () => {
    this.ctaElement = document.querySelector("#cta-copy")
    this.setState(
      {
        ctaCopy: "Disconnected",
        playMeterAnimation: false,
        playDisableAnimation: false,
        playSuccessAnimation: true,
      },
      () => {
        this.ctaElement.addEventListener(
          AnimationEvent(),
          this.handleCtaAnimationEnd
        )
        this.meterElement.removeEventListener(
          AnimationEvent(),
          this.handleMeterAnimationEnd
        )
      }
    )
  }

  handleCtaAnimationEnd = () => {
    this.setState(
      {
        ctaCopy: this.ctaCopyToConnect(),
        showKnob: true,
        playSuccessAnimation: false,
      },
      () => {
        this.ctaElement.removeEventListener(
          AnimationEvent(),
          this.handleCtaAnimationEnd
        )
      }
    )
  }

  ctaCopyToConnect = () => {
    return this.props.programmable
      ? `Connect ${this.props.mainService.short_name}`
      : "Connect"
  }
}

ReconnectButton.propTypes = {
  mainService: PropTypes.object.isRequired,
  services: PropTypes.array.isRequired,
  onConnectClick: PropTypes.func.isRequired,
  connectClicked: PropTypes.bool.isRequired,
  disconnectClicked: PropTypes.bool.isRequired,
  showKnob: PropTypes.bool,
  ctaCopy: PropTypes.string,
  connected: PropTypes.bool,
  programmable: PropTypes.bool,
  defaultBgColor: PropTypes.object,
  animation: PropTypes.object.isRequired,
  updateAnimationCol: PropTypes.func.isRequired,
  connectButtonMaxFontSize: PropTypes.number,
  knobBgColorForDarkBrands: PropTypes.bool,
}

ReconnectButton.defaultProps = {
  ctaCopy: "Reconnect",
  defaultBgColor: { backgroundColor: colors.primaryTextColor },
  showKnob: false,
  connected: false,
  connectButtonMaxFontSize: 30,
}
